export enum WidgetViews {
    PROCESSING = 'processing',
    LOADING = 'loading',
    ERROR = 'error',
    CLOSE_WIDGET = 'close-widget',
    CUSTOM_PAGE_PREVIEW = 'custom-page-preview'
}

export type WidgetApps =
    | 'custom-page'
    | 'autopay-verification-payment'
    | 'transactionlink-open-banking'
    | 'twilio'
    | 'veriff-video-verification'
    | 'veriff'
    | 'veriff-age-estimation'
    | 'zoho-sign'
    | 'ondato-vv'
    | 'workflow-finish'
    | 'moje-id-verification'
    | 'gbg-id-verification'
    | 'mobywatel-id-verification'
    | 'au10tix-video-verification'
